import { render, staticRenderFns } from "./TelegramMessageDetailModal.vue?vue&type=template&id=d36a4b18&scoped=true&"
import script from "./TelegramMessageDetailModal.vue?vue&type=script&lang=js&"
export * from "./TelegramMessageDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./TelegramMessageDetailModal.vue?vue&type=style&index=0&id=d36a4b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36a4b18",
  null
  
)

export default component.exports